<h1 mat-dialog-title>{{'switch_user_role.switch' | translate}}</h1>
<div mat-dialog-content>
  <p>{{'switch_user_role.switch_personal_business_logout' | translate}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{'switch_user_role.cancel' | translate}}</button>
  <button mat-button (click)="onProceed()" cdkFocusInitial>{{'switch_user_role.logout' | translate}}</button>
</div>